export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const isSessionCookieTrue = () => {
  const raw = (getCookie("session_exists") || "").toLowerCase();
  return raw === "true" || raw === "1";
};

// backend encodes vanity as URL-safe base64 without padding
export const decodeBase64Url = (raw) => {
  if (!raw) return "";
  try {
    const b64 = raw.replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    return atob(padded);
  } catch (e) {
    console.error("Failed to decode base64url:", e);
    return "";
  }
};

export const getVanityFromCookie = () => {
  const vanity = decodeBase64Url(getCookie("vanity") || "").trim().toLowerCase();
  return /^[a-z0-9-]+$/.test(vanity) ? vanity : "";
};

export const getCsrfToken = () => getCookie("csrf_token") || "";